<template>
  <div
    class="w-full mx-auto px-6 sm:px-7 md:px-4 lg:px-10 xl:px-16 max-w-screen-sm md:max-w-screen-2xl py-20"
  >
    <h2
      class="text-3xl font-bold text-center mb-12 text-gray-900 px-4 sm:px-6 md:px-8 lg:px-32"
    >
      {{ title }}
    </h2>
    <div
      class="flex flex-col md:flex-row justify-between gap-7 sm:gap-7 md:gap-7 lg:gap-12 w-full"
    >
      <div
        v-for="(element, index) in elements"
        :key="element.id || index"
        class="box px-6 py-8 flex flex-col items-start rounded-xl shadow-md transition-all duration-1000 ease-in-out w-full md:w-1/3 min-w-[230px] flex-1"
      >
        <div
          class="flex-shrink-0"
          :class="element.imageStyle"
          v-if="element.imageSrc"
        >
          <img
            :src="element.imageSrc"
            :alt="element.imageAlt"
            class="w-full h-full object-contain rounded-lg"
          />
        </div>

        <h3 class="text-2xl font-semibold my-3">{{ element.title }}</h3>

        <div
          class="card-text mb-3 max-w-none text-base leading-6 text-gray-900"
          v-html="element.text"
        ></div>

        <a
          :href="element.seeMoreUrl"
          class="link flex items-end gap-2 flex-1"
          v-if="element.seeMoreUrl"
        >
          <div>
            See more
            <font-awesome-icon :icon="['fas', 'arrow-right']" class="w-4 h-4" />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    elements: {
      type: Array,
      required: true,
    },
    hoverAnimation: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.card-text :deep(ul),
.card-text :deep(ol) {
  padding-left: 1.25rem;
}

.card-text :deep(ul) {
  list-style-type: disc;
}

.card-text :deep(ol) {
  list-style-type: decimal;
}
</style>
